// extracted by mini-css-extract-plugin
module.exports = {"editorialTaxonomy":"EditorialTaxonomy_editorialTaxonomy__t2X3N"};